<template>
  <AuxiliaryList
    :items="contactLensTestManufacturers"
    typeName="fabricante"
    :deleteMutation="deleteItem"
    :saveMutation="save"
    :refreshList="refreshList"
  />
</template>

<script>
  import AuxiliaryList from "@/components/config/contact_len/auxiliary/list.vue";

  export default {
    name: "ContactLenManufacturerConfig",
    components: {
      AuxiliaryList,
    },
    apollo: {
      contactLensTestManufacturers: {
        query: require("@/graphql/contact_lens_test/manufacturers.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      deleteItem({ id }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/delete_contact_lens_manufacturer.gql"),
          variables: {
            contactLensManufacturerId: id,
          },
        });
      },
      save({ id, name }) {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/save_contact_lens_manufacturer.gql"),
          variables: {
            contactLensManufacturerId: id,
            name: name,
          },
        });
      },
      refreshList() {
        return this.$apollo.queries.contactLensTestManufacturers.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
